import React, { Component } from 'react'

import ResetPasswordFormModal from './reset-password-form-modal'

import './launch-reset-password-form.scss'

const LaunchResetPasswordFormModal = class extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modalShow: false,
    }

    this.launch = this.launch.bind(this)
    this.close = this.close.bind(this)
  }

  launch = () => { this.setState({modalShow: true}) }
  close = () => { this.setState({modalShow: false}) }

  render() {
    return (
      <React.Fragment>
        <span
          id="reset-password-form-modal"
          variant="outline-primary"
          onClick={this.launch}
          className={this.props.childrenclass}
        >
          {this.props.children}
        </span>
        <ResetPasswordFormModal
          show={this.state.modalShow}
          onHide={this.close}
        />
      </React.Fragment>
    )
  }
}

export default LaunchResetPasswordFormModal